/**
 * London Smoke & Cure — display name for the Admin Xero finance desk.
 * Route stays `/invoicer` (and `/Invoicer`) so bookmarks and OAuth redirects keep working.
 */

export const XERO_DAY_LABEL = 'Xero day';

/** Canonical SPA path (lowercase). */
export const XERO_DAY_PATH = '/invoicer';
